import executeRequest from "../../../../modules/request.js";
import { UpdateBasketItemsCount } from "../components/navbar/navBar.js";
import { useGlobalUpdate } from "./useGlobalUpdate.js";
export class Bucket {
    constructor() {
        this.orders = [];
        this.fetch();
    }
    async fetch() {
        const response = await executeRequest("/api/public/users/gallery/orders/get", "GET", {});
        if (response.status !== 200) {
            sessionStorage.setItem("logged", "false");
            this.orders = [];
            return response;
        }
        this.orders = JSON.parse(JSON.stringify(response.images));
        useGlobalUpdate(UpdateBasketItemsCount).emit(this.orders.length);
        return response;
    }
    update(order) {
        const hasOrder = this.hasOrder(order.imageName, order.offerName);
        if (!hasOrder)
            return void this.orders.push(order);
        this.orders = this.orders.map((localOrder) => (localOrder.imageName != order.imageName &&
            localOrder.offerName != order.offerName) ?
            localOrder
            : order);
    }
    hasOrder(imageName, offerName) {
        return this.orders.some((order) => order.offerName === offerName && order.imageName === imageName);
    }
    get updateBucketFromServer() {
        return this.fetch;
    }
}
export class BucketManager {
    constructor() {
        this.bucket = new Bucket();
    }
    async insertOrder(imageName, offerData, selectedCustomization) {
        const orderedFormats = offerData.formats.map((format) => {
            var _a;
            return ({
                name: format.name,
                count: (_a = format.count) !== null && _a !== void 0 ? _a : 0,
            });
        });
        const orderStructure = {
            image: imageName,
            offerName: offerData.name,
            formats: orderedFormats,
            selectedCustomization,
        };
        const result = await executeRequest("/api/public/users/gallery/orders/add", "POST", orderStructure);
        if (result.status == 200)
            this.bucket.update({
                formats: orderedFormats,
                imageName: imageName,
                offerName: offerData.name,
            });
        if (result.status != 200) {
            throw result.status;
        }
    }
    get Bucket() {
        return this.bucket;
    }
}
